module.exports = __webpack_public_path__ + "static/media/29BDOS27.d69186f2.jpg";